import {i as p, a as g} from '@theme/card-image';
const a = 'model',
  o = 'item',
  v = 'product-card',
  k = '.card__media img[data-model-image]';
function n(d) {
  return d === o ? o : a;
}
let exposureRecorded = false;

// These are the two theme versions prepared for rollout 9339251. Identify the
// version served independently of collection overrides or the current toggle.
// This is not Shopify's internal visitor assignment. Reports must use the
// rollout's actual active dates; these theme versions also exist outside it.
const rolloutThemeVariants = {
  '195327525235': 'model',
  '195708649843': 'item',
};

function servedRolloutContext() {
  const variant = rolloutThemeVariants[String(window.Shopify?.theme?.id || '')];
  return variant ? {rollout_id: '9339251', served_variant: variant} : {};
}

// Shopify's pixel manager applies the receiving pixel's consent requirements.
// Keep analytics failures independent of the image controls.
function publishImageEvent(name, data) {
  try {
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function' || window.Shopify?.designMode) return false;
    const result = analytics.publish(name, data);
    if (result && typeof result.catch === 'function') result.catch(() => {});
    return result !== false;
  } catch {
    return false;
  }
}
class E extends HTMLElement {
  constructor() {
    super(),
      (this.view = a),
      (this.onButtonClick = this.onButtonClick.bind(this)),
      (this.onTrackClick = this.onTrackClick.bind(this)),
      (this.onGridRendered = this.onGridRendered.bind(this));
  }
  connectedCallback() {
    this.hasInitialView ||
      ((this.defaultView = n(this.getAttribute('data-default-view'))),
      (this.view = this.defaultView),
      (this.rolloutContext = servedRolloutContext()),
      (this.hasInitialView = !0)),
      this.updateButtons(),
      this.applyState(this.view),
      this.recordExposure(),
      this.querySelectorAll('[data-view]').forEach((t) => {
        t.addEventListener('click', this.onButtonClick);
      }),
      (this.track = this.querySelector('.plp-image-toggle__track')),
      this.track && this.track.addEventListener('click', this.onTrackClick),
      document.addEventListener('plp:grid-rendered', this.onGridRendered);
  }
  disconnectedCallback() {
    this.querySelectorAll('[data-view]').forEach((t) => {
      t.removeEventListener('click', this.onButtonClick);
    }),
      this.track && (this.track.removeEventListener('click', this.onTrackClick), (this.track = null)),
      document.removeEventListener('plp:grid-rendered', this.onGridRendered);
  }
  onGridRendered() {
    this.applyState(this.view);
  }
  onTrackClick() {
    const t = this.view === a ? o : a;
    this.setView(t, 'track');
  }
  onButtonClick(t) {
    const i = t.currentTarget;
    if (!(i instanceof HTMLButtonElement)) return;
    const s = n(i.dataset.view);
    this.setView(s, 'button');
  }
  setView(t, interaction) {
    const previousView = this.view;
    const nextView = n(t);
    if (previousView === nextView) return;
    this.view = nextView;
    this.updateButtons();
    this.applyState(this.view);
    if (interaction === 'button' || interaction === 'track') {
      this.recordExposure();
      publishImageEvent('elk:plp_image_switched', {
        ...this.analyticsContext(),
        from_view: previousView,
        to_view: this.view,
        interaction,
      });
    }
  }
  analyticsContext() {
    return {
      ...this.rolloutContext,
      default_view: this.defaultView,
      collection_handle: this.dataset.collectionHandle || '',
      page_type: this.dataset.pageType || '',
      theme_id: String(window.Shopify?.theme?.id || ''),
    };
  }
  recordExposure() {
    if (!exposureRecorded) {
      exposureRecorded = publishImageEvent('elk:plp_image_viewed', this.analyticsContext());
    }
  }
  updateButtons() {
    this.setAttribute('data-current-view', this.view),
      this.querySelectorAll('[data-view]').forEach((t) => {
        if (!(t instanceof HTMLButtonElement)) return;
        const i = n(t.dataset.view) === this.view;
        t.classList.toggle('plp-image-toggle__btn--active', i), t.setAttribute('aria-pressed', String(i));
      });
  }
  applyState(t) {
    document.querySelectorAll(v).forEach((s) => {
      if (p(s.dataset.productType)) return;
      const e = s.querySelector(k);
      if (!(e instanceof HTMLImageElement)) return;
      const r = e.dataset.modelImage,
        c = e.dataset.clearcutImage;
      if (!r || !c || r === c) return;
      const l = Number.parseInt(e.dataset.modelWidth, 10),
        h = Number.parseInt(e.dataset.modelHeight, 10),
        u = Number.parseInt(e.dataset.clearcutWidth, 10),
        m = Number.parseInt(e.dataset.clearcutHeight, 10);
      g(e, r, c, l, t, h, u, m);
    }),
      document.dispatchEvent(new CustomEvent('plp:view-changed'));
  }
}
customElements.define('plp-image-toggle', E);
